import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CursoService } from 'src/app/servicios/curso.service';
import { CursoUsuarioService } from 'src/app/servicios/curso-usuario.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-miscursos',
  templateUrl: './miscursos.component.html',
  styleUrls: ['./miscursos.component.scss']
})
export class MiscursosComponent implements OnInit {
 
  
  public arry=[];
  public muestro = false;
  public email;
  constructor(private cursoSvc:CursoUsuarioService, private cursSvc:CursoService, private router:Router) { }

  ngOnInit(): void {
    let cursos;
    
    this.cursoSvc.getAllUsuarioCurso().subscribe(res=>
      {
        //console.log(res);
        cursos = res;
        //this.dataSource.data = res;
         this.cursoSvc.verUserData().subscribe(res=>
          {
            this.email = res.email;
            cursos.forEach(element => {
              
              if(element.data.usuario == res.uid)
              {
                //this.dataSource.data.push(element)
                //this.arry.push(element)      
                this.cursSvc.getOneCurso(element.data.curso).subscribe(res=>
                  {
                    //console.log("entro con: ", res);
                    this.arry.push(res)
                  })          
              }
            });
          })
      })

  
      
  }//fin oninit

  irACurso(id)
  {
    //console.log(id);
    this.router.navigate(["/reproducir/" + id]);
  }
}
